export default __webpack_public_path__ + "static/media/icons-star-outline.1a793619.svg";